import React, { useContext, useState, useMemo, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Check2, ChatLeftDots, FileEarmarkText, FileBarGraph } from 'react-bootstrap-icons'
import axiosService from '../../../../../utils/AxiosService'
import { useParams } from 'react-router-dom'
import { toastSuccess, toastError } from '../../../../FormComponents/Toasts'
import UploadSelectPanel from './DraftReviewWindowParts/UploadSelectPanel'
import Action from '../../../../../models/Action'
import DraftUpload from '../../../../../models/DraftUpload'
import ImageWindow from './DraftReviewWindowParts/ImageWindow'
import VideoWindow from './DraftReviewWindowParts/VideoWindow'
import CommentsSidebar from './DraftReviewWindowParts/CommentsSidebar'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'
import { useSidebarCollapse } from '../../../../../contexts/SidebarCollapseContext'

const DRAFT_LIST_WIDTH = 353

export default observer(function DraftReviewWindow() {
  const { action_id } = useParams()
  const { draftActions, selectedUpload, setSelectedUpload } = useContext(SharedCampaignContext)
  const { isCollapsed } = useSidebarCollapse()
  const currentAction = useMemo(() => draftActions?.find(action => +action.id === +action_id) || new Action(), [action_id, draftActions, draftActions?.length])
  const [showCommentsSidebar, setShowCommentsSidebar] = useState(false)

  const leftOffset = (isCollapsed ? 64 : 224) + DRAFT_LIST_WIDTH
  const width = `calc(100vw - ${leftOffset}px)`

  useEffect(() => {
    if (currentAction.id) {
      if (currentAction.draft_uploads.length > 0) {
        setSelectedUpload(currentAction.draft_uploads[0])
      } else {
        setSelectedUpload(new DraftUpload())
      }
    }
  }, [currentAction.id, currentAction.draft_uploads.length])

  const updateToApproveAction = () => {
    axiosService.patch(
      `/api/advertiser/campaign_share/actions/${action_id}`,
      {action_data: { advertiser_approved: !currentAction.advApproved } }
    ).then((updatedAction) => {
      console.log('updatedAction', updatedAction)
      currentAction.advApproved = updatedAction.advertiser_approved
      console.log('currentAction', currentAction)
      updatedAction.advertiser_approved ? toastSuccess('This action is approved!') : toastSuccess('This action is no longer approved!')
    }).catch(() => toastError('Unable to approve action at this time.'))
  }

  return (
    <div
      className="fixed top-[0] h-full flex flex-col justify-center items-center overflow-y-auto transition-all duration-300"
      style={{
        left: `${leftOffset}px`,
        width
      }}
    >
      <div className="h-full">
        <div className='my-5 p-3 rounded-lg bg-white dark:bg-rb-dark-mode flex justify-between items-center w-[650px] border-1 border-primary dark:border-rb-dark-mode-lighter'>
          <h2 className='font-bold text-xl dark:text-white'>{currentAction.name}</h2>
          <button
            className={`flex items-center ${currentAction.advApproved ? 'bg-rb-green text-white dark:bg-rb-green dark:text-white' : 'hover:bg-gray-100 dark:hover:bg-rb-dark-mode-lighter'} rounded-lg p-2 dark:text-white`}
            onClick={updateToApproveAction}
          >
            <Check2 />
            <span className={`ml-1 text-sm font-bold ${currentAction.advApproved ? 'text-white' : ''}`}>{currentAction.advApproved ? 'Approved' : 'Approve'}</span>
          </button>
        </div>

        <UploadSelectPanel action={currentAction} />

        { selectedUpload.id && ['mov', 'mp4'].includes(selectedUpload.fileType) ? <VideoWindow /> : selectedUpload.id ? <ImageWindow /> : null}

        <div className='my-5 p-3 rounded-lg bg-white dark:bg-rb-dark-mode flex justify-between items-center w-[650px] border-1 border-primary dark:border-rb-dark-mode-lighter'>
          <div className='flex gap-2 items-center'>
            <button
              onClick={() => setShowCommentsSidebar(!showCommentsSidebar)}
              className='p-2 flex gap-2 items-center rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white'
            >
              <ChatLeftDots />
              <span>Comments</span>
            </button>
          </div>
        </div>
        <div className="pb-2">
          <div className='my-5 p-3 rounded-lg bg-white dark:bg-rb-dark-mode flex flex-col gap-2 w-[650px] border-1 border-primary dark:border-rb-dark-mode-lighter'>
            <h2 className="font-bold text-md dark:text-white">Caption:</h2>
            <p className="dark:text-white">{currentAction.caption}</p>
          </div>
        </div>
        {showCommentsSidebar && <CommentsSidebar onClose={() => setShowCommentsSidebar(false)} /> }
      </div>
    </div>
  )
})
